import { call, put, select, takeLatest } from 'typed-redux-saga'
import {
	errorHandler,
	notifyMessageCreator,
	UserSettingNS,
	userSettingSelectors,
	userSettingSlice,
	UserSettingApi,
} from 'Modules'

export function* getSettingsSaga(action: UserSettingNS.GetSettings) {
	try {
		const res = yield* call(UserSettingApi.getAll)
		if (res.data === null) res.data = {}
		yield* put(userSettingSlice.actions.setSettings(res))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

export function* updateSettingsSaga(action: UserSettingNS.UpdateSettings) {
	try {
		const { data, key, isShowNotification = true, callback } = action.payload
		const res = { ...(yield* select(userSettingSelectors.getAll)) }
		res[key] = data
		const updateRes = yield* call(UserSettingApi.updateSettings, res)
		yield* put(userSettingSlice.actions.setSettings(updateRes))
		if (isShowNotification) yield* call(notifyMessageCreator, 'common.user_settings_update.success')
		callback?.()
	} catch (error) {
		yield* call(errorHandler, error)
		action.payload.errorCallback?.()
	}
}

export function* userSettingSaga() {
	yield* takeLatest(userSettingSlice.actions.updateSettings.type, updateSettingsSaga)
	yield* takeLatest(userSettingSlice.actions.getSettings.type, getSettingsSaga)
}
